import { AppRoutes } from '@/routes'

/**
 * App root component.
 *
 * Routing is declared in `src/routes/index.tsx` and mounted here.
 * Providers (QueryClient, BrowserRouter) live in `src/main.tsx`.
 */
export default function App() {
  return <AppRoutes />
}
